var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg012Hydrant = function Svg012Hydrant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 512h420v-30h-60v-30H106v30H46zM241 0v31.516C192.045 37.718 152.443 73.147 140.261 120H106v30h300v-30h-34.261C359.557 73.147 319.955 37.718 271 31.516V0zM76 241h30v120H76zM406 241h30v120h-30z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 301,
    r: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376 422V180H136v242zM256 241c33.091 0 60 26.909 60 60s-26.909 60-60 60-60-26.909-60-60 26.909-60 60-60"
  })));
};
export default Svg012Hydrant;